import { Lock } from "lucide-react";
import Monogram from "./Monogram";
import { WEDDING } from "@/data/wedding";

export default function Footer({ onAdminOpen }) {
  return (
    <footer className="border-t border-line py-14">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-5 text-center sm:px-8">
        <Monogram className="h-12 w-12" />
        <p className="mt-5 font-serif text-2xl text-ink">
          {WEDDING.bride} &amp; {WEDDING.groom}
        </p>
        <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.3em] text-fog">
          {WEDDING.dateLong} — {WEDDING.city}
        </p>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-taupe">
          Merci d'être parmi nous pour écrire avec nous le plus beau des chapitres.
        </p>
        <button
          type="button"
          data-testid="footer-admin-trigger"
          onClick={onAdminOpen}
          className="mt-9 inline-flex items-center gap-2 text-xs text-fog transition-colors hover:text-terracotta"
        >
          <Lock className="h-3.5 w-3.5" />
          Espace mariés
        </button>
      </div>
    </footer>
  );
}
